import { UserApi } from "@utils/api/ec";

type LogEventPayload = {
	category: string;
	path: string;
	action: string;
	event: string;
};

type HandleSendOaMessageArgs = {
	isLoading: boolean;
	setIsLoading: (v: boolean) => void;
	logEvent: (payload: LogEventPayload) => unknown;

	log: LogEventPayload;
	styleCode: string;
	type: string;
	onSuccess?: () => void;
	setIsChooseStoreOpen: (v: boolean) => void;
};

export async function handleSendOaMessage({
	isLoading,
	setIsLoading,
	logEvent,
	log,
	styleCode,
	type,
	onSuccess,
	setIsChooseStoreOpen,
}: HandleSendOaMessageArgs) {
	if (isLoading) return;

	logEvent(log);

	try {
		setIsLoading(true);
		const res = await UserApi.sendOaMessage(styleCode, type);
		if (res.status === 1) {
			onSuccess?.();
		} else if (res.status === 0) {
			setIsChooseStoreOpen(true);
		}
	} catch (e) {
		console.error("sendOaMessage failed", e);
	} finally {
		setIsLoading(false);
	}
}
